// @flow
export const normalizeBoolean = (value: string) => {
  if (value === 'true') {
    return true
  }

  if (value === 'false') {
    return false
  }

  return value
}

export const normalizeGBP = (value: string) => {
  const actualValue = `${value}`.replace(/\D+/g, '')
  return actualValue !== '' ? `£${actualValue}` : ''
}

export const greaterThanZero = (value: number) => (parseFloat(value) > parseFloat(-1) ? value : '')

export const normalizeSelect = (value: string) => {
  return value
}

export const roundToTwo = (num: number) => {
  const roundedNum = +(Math.round(Number(num + 'e+2')) + 'e-2')
  return roundedNum.toFixed(2)
}



// WEBPACK FOOTER //
// ./src/helpers/normalize.js